import script from "./FormPriceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPriceComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPriceComponent.vue?vue&type=style&index=0&id=b2827964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2827964"]])

export default __exports__